import axios from '@axios'

function mapClassificator(raw) {
  if (!raw) return null
  return {
    id: raw._id || raw.id,
    name: raw.name,
    nameEn: raw.nameEn,
    parent: raw.parent ? String(raw.parent._id || raw.parent) : null,
    note: raw.note || null,
    ordering: typeof raw.ordering === 'number' ? raw.ordering : 0,
    status: !!raw.status,
    hideForTrailers: !!raw.hideForTrailers,
  }
}

export default {
  namespaced: true,
  state: {
    classificators: [],
    engineTypes: [],
    itfs: [],
    pagination: {
      total: 0,
      count: 20,
      current_page: 1,
    },
    add: false,
    edit: false,
    form: {},
    copy: false,
    copy_form: {},
    selectedItf: null,
    docs: {
      print: false,
    },
    company: null,
  },
  getters: {},
  mutations: {
    SET_CLASSIFICATORS(state, data) {
      state.classificators = data
    },
    ADD_CLASSIFICATOR(state, item) {
      state.classificators.push(item)
    },
    UPDATE_CLASSIFICATOR(state, item) {
      const index = state.classificators.findIndex((i) => i.id === item.id)
      if (index !== -1) {
        Object.assign(state.classificators[index], item)
      }
    },
    DELETE_CLASSIFICATOR(state, id) {
      const index = state.classificators.findIndex((i) => i.id === id)
      if (index !== -1) {
        state.classificators.splice(index, 1)
      }
    },

    SET_ENGINE_TYPES(state, data) {
      state.engineTypes = data
    },
    ADD_ENGINE_TYPE(state, item) {
      state.engineTypes.push(item)
    },
    UPDATE_ENGINE_TYPE(state, item) {
      const index = state.engineTypes.findIndex((i) => i.id === item.id)
      if (index !== -1) {
        Object.assign(state.engineTypes[index], item)
      }
    },
    DELETE_ENGINE_TYPE(state, id) {
      const index = state.engineTypes.findIndex((i) => i.id === id)
      if (index !== -1) {
        state.engineTypes.splice(index, 1)
      }
    },

    SET_ITFS(state, payload) {
      state.itfs = payload.data || []
      if (payload.pagination) {
        state.pagination = payload.pagination
      }
    },
    ADD_ITF(state, item) {
      state.itfs.unshift(item)
    },
    UPDATE_ITF(state, item) {
      const id = item.id || item._id
      const index = state.itfs.findIndex((i) => (i.id || i._id) === id)
      if (index !== -1) {
        Object.assign(state.itfs[index], item)
      }
    },
    DELETE_ITF(state, id) {
      const index = state.itfs.findIndex((i) => (i.id || i._id) === id)
      if (index !== -1) {
        state.itfs.splice(index, 1)
      }
    },
    CHANGE_ADD_STATE(state, value) {
      state.add = value
      if (!value) {
        state.copy = false
        state.copy_form = {}
      }
    },
    OPEN_EDIT_FORM(state, data) {
      state.form = JSON.parse(JSON.stringify(data))
      state.edit = true
      state.add = false
    },
    CLOSE_EDIT_FORM(state) {
      state.edit = false
      state.form = {}
    },
    SET_COPY_FORM(state, data) {
      state.copy = true
      state.copy_form = JSON.parse(JSON.stringify(data))
    },
    SET_SELECTED_ITF(state, data) {
      state.selectedItf = data
    },
    OPEN_DOC(state, doc) {
      state.docs[doc] = true
    },
    CLOSE_DOC(state, doc) {
      state.docs[doc] = false
    },
    SET_COMPANY(state, data) {
      state.company = data
    },
  },
  actions: {
    getClassificators({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('itf/classificators')
          .then((response) => {
            const list = (response.data.data || []).map(mapClassificator).filter(Boolean)
            commit('SET_CLASSIFICATORS', list)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    addClassificator({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post('itf/classificators', data)
          .then((response) => {
            const item = mapClassificator(response.data.item)
            commit('ADD_CLASSIFICATOR', item)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    editClassificator({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.put('itf/classificators/' + data.id, data)
          .then((response) => {
            const item = mapClassificator(response.data.item)
            commit('UPDATE_CLASSIFICATOR', item)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    deleteClassificator({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.delete('itf/classificators/' + id)
          .then((response) => {
            commit('DELETE_CLASSIFICATOR', id)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getEngineTypes({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('itf/engine-types')
          .then((response) => {
            commit('SET_ENGINE_TYPES', response.data.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    addEngineType({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post('itf/engine-types', data)
          .then((response) => {
            const item = {
              id: response.data.item._id,
              name: response.data.item.name,
              nameEn: response.data.item.nameEn,
              status: response.data.item.status,
            }
            commit('ADD_ENGINE_TYPE', item)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    editEngineType({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.put('itf/engine-types/' + data.id, data)
          .then((response) => {
            const item = {
              id: response.data.item._id,
              name: response.data.item.name,
              nameEn: response.data.item.nameEn,
              status: response.data.item.status,
            }
            commit('UPDATE_ENGINE_TYPE', item)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    deleteEngineType({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.delete('itf/engine-types/' + id)
          .then((response) => {
            commit('DELETE_ENGINE_TYPE', id)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getItfs({ commit }, query = {}) {
      const params = new URLSearchParams(query).toString()
      return new Promise((resolve, reject) => {
        axios.get(`itf?${params}`)
          .then((response) => {
            commit('SET_ITFS', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getAllItfs({ commit }, query = {}) {
      const params = new URLSearchParams(query).toString()
      return new Promise((resolve, reject) => {
        axios.get(`itf-all?${params}`)
          .then((response) => {
            commit('SET_ITFS', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getViewItfs({ commit }, query = {}) {
      const params = new URLSearchParams(query).toString()
      return new Promise((resolve, reject) => {
        axios.get(`itf-view?${params}`)
          .then((response) => {
            commit('SET_ITFS', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getCompanyItfs({ commit }, query = {}) {
      const params = new URLSearchParams(query).toString()
      return new Promise((resolve, reject) => {
        axios.get(`itf-company?${params}`)
          .then((response) => {
            commit('SET_ITFS', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    addItf({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post('itf', data)
          .then((response) => {
            commit('ADD_ITF', response.data.item)
            commit('SET_SELECTED_ITF', response.data.item)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getItf({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.get('itf/' + id)
          .then((response) => {
            commit('SET_SELECTED_ITF', response.data.data)
            commit('UPDATE_ITF', response.data.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    editItf({ commit }, data) {
      const id = data._id || data.id
      return new Promise((resolve, reject) => {
        axios.put('itf/' + id, data)
          .then((response) => {
            commit('UPDATE_ITF', response.data.item)
            commit('SET_SELECTED_ITF', response.data.item)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    editAdminItf({ commit }, data) {
      const id = data._id || data.id
      return new Promise((resolve, reject) => {
        axios.put('itf-all/' + id, data)
          .then((response) => {
            commit('UPDATE_ITF', response.data.item)
            commit('SET_SELECTED_ITF', response.data.item)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    deleteItf({ commit }, item) {
      const id = typeof item === 'object' ? (item._id || item.id) : item
      return new Promise((resolve, reject) => {
        axios.delete('itf/' + id)
          .then((response) => {
            commit('DELETE_ITF', id)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    deleteAdminItf({ commit }, item) {
      const id = typeof item === 'object' ? (item._id || item.id) : item
      return new Promise((resolve, reject) => {
        axios.delete('itf-all/' + id)
          .then((response) => {
            commit('DELETE_ITF', id)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    getCompany({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('tech-service-company')
          .then((response) => {
            commit('SET_COMPANY', response.data.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
}
